var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"closeButton"},[_c('iconfont',{attrs:{"name":"#icon20-12guanbianniujiaohu","font-size":"12px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }